export const BRAND_NAME_RU = "ФармХаб";
export const BRAND_NAME_EN = "PharmHub";
export const BRAND_TECHNICAL_ID = "pharmhub";
